import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useAuthorized from "hooks/useAuthorized";
import { useCallDispositionsMutations } from "hooks/useCallDispositionsTable";
import CallDispositionModal from "routes/call_dispositions/components/CallDispositionModal";
import DeleteDispositionModal from "routes/call_dispositions/components/DeleteDispositionModal";

export function CallDispositionsTableActions({ original, parentDispositions }) {
  const canEdit = useAuthorized([ACL_RELATIONSHIPS.disposition.edit]);
  const canDelete = useAuthorized([ACL_RELATIONSHIPS.disposition.delete]);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const { remove } = useCallDispositionsMutations({
    onDeleted: () => setDeleteOpen(false),
  });

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Disposition actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {canEdit && (
        <CallDispositionModal
          model={original}
          parentDispositions={parentDispositions}
          open={editOpen}
          onOpenChange={setEditOpen}
        />
      )}
      {canDelete && (
        <DeleteDispositionModal
          open={deleteOpen}
          onOpenChange={setDeleteOpen}
          dispositionId={original.id}
          dispositionName={original.name}
          onConfirm={() => remove.mutate(original.id)}
        />
      )}
    </>
  );
}
